"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIMTokenContents = void 0;
const errors_1 = require("../../shared/errors");
function getIMTokenContents(token) {
    const decodedToken = Buffer.from(token, 'base64').toString('utf-8');
    const username = decodedToken.split(':')[0];
    const userToken = Buffer.from(`${username}:`, 'utf-8').toString('base64');
    if (decodedToken.length < 2) {
        throw new errors_1.OperationError(errors_1.OperationErrorCode.InvalidValue, 'token');
    }
    const secretKey = decodedToken.split(':')[1];
    const tokenContents = { username, userToken, secretKey };
    return tokenContents;
}
exports.getIMTokenContents = getIMTokenContents;
